import { useEffect, useRef, useState } from 'react';
import { AppStateValue, GlobalState } from '../lib/global';

export const useGlobalState = (globalState: GlobalState<AppStateValue>) => {
  const [state, setState] = useState<AppStateValue>(() => globalState.getValue());
  const reRender = useRef(() => setState(globalState.getValue())).current;

  useEffect(() => {
    // Sync nel caso il valore sia cambiato tra il render e il mount
    reRender();
    globalState.subscribe(reRender);
    return () => globalState.unsubscribe(reRender);
  }, [globalState, reRender]);

  return [state, (newState: AppStateValue) => globalState.setValue(newState)] as const;
};
